import { useState } from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap';
import Slider from "react-slick";

import './Castle.css'
import { useTranslation } from 'react-i18next';

function Castle() {

    const settings = {
        className: "mx-5 h-100 d-flex justify-content-center align-items-center",
        dots: false,
        arrows: false,
        centerMode: true,
        infinite: true,
        slidesToShow: 3,
        speed: 500,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    className: "mx-1",
                    centerMode: true,
                    infinite: true,
                    slidesToShow: 2,
                    speed: 500,
                    arrows: false,
                    dots: false,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    dots: false,
                    className: "mx-0",
                    arrows: false,
                    centerMode: true,
                    infinite: true,
                    slidesToShow: 1,
                    speed: 500,
                }
            }
        ]
    };

    const { t } = useTranslation()

    return (
        <>
            <section className="container-fluid castle-upperpanel" id='section_3'>
                <div className="container-lg h-100">
                    <div className="row h-100 align-items-center">
                        <div className="col-md-6 castle-upperpanel__item">
                            <p>{t("castle.header")}</p>
                        </div>
                        <div className="col-md-6 castle-upperpanel__item">
                            <img src="images/zamek-w-stobnicy-2.webp" alt="Zamek w Stobnicy" />
                        </div>
                    </div>
                </div>
            </section>
            <section className="container-lg timeline">
                <div className="timeline-container left-container">
                    <div className="timeline-container__text-box" >
                        <img src="images/wieza-glowa-po.webp" alt="Wieża zbudowana z kamienia naturalnego" data-aos="fade-up" />
                        <h2 data-aos="fade-up">{t("castle.castle1.title")}</h2>
                        <small data-aos="fade-up">{t("castle.castle1.date")}</small>
                        <p data-aos="fade-up">{t("castle.castle1.message")}</p>
                        <hr className='left-container-arrow'></hr>
                    </div>
                </div>
                <div className="timeline-container right-container">
                    <div className="timeline-container__text-box">
                        <img src="images/wieza polnocno wschodnia.png" alt="Wieża kamienna" data-aos="fade-up" />
                        <h2 data-aos="fade-up">{t("castle.castle2.title")}</h2>
                        <small data-aos="fade-up">{t("castle.castle2.date")}</small>
                        <p data-aos="fade-up">{t("castle.castle2.message")}</p>
                        <hr className='right-container-arrow'></hr>
                    </div>
                </div>
                <div className="timeline-container left-container">
                    <div className="timeline-container__text-box">
                        <img src="images/wieza-glowna.webp" alt="Główna wieża w Stobnicy" data-aos="fade-up" />
                        <h2 data-aos="fade-up">{t("castle.castle3.title")}</h2>
                        <small data-aos="fade-up">{t("castle.castle3.date")}</small>
                        <p data-aos="fade-up">{t("castle.castle3.message")}</p>
                        <hr className='left-container-arrow'></hr>
                    </div>
                </div>
                <div className="timeline-container right-container">
                    <div className="timeline-container__text-box">
                        <img src="images/wieza-zegarowa.webp" alt="Wieża zegarowa" data-aos="fade-up" />
                        <h2 data-aos="fade-up">{t("castle.castle4.title")}</h2>
                        <small data-aos="fade-up">{t("castle.castle4.date")}</small>
                        <p data-aos="fade-up">{t("castle.castle4.message")}</p>
                        <hr className='right-container-arrow'></hr>
                    </div>
                </div>
                <div className="timeline-container left-container">
                    <div className="timeline-container__text-box">
                        <img src="images/wjazd-glowny.webp" alt="Wjazd na Zamek" data-aos="fade-up" />
                        <h2 data-aos="fade-up">{t("castle.castle5.title")}</h2>
                        <small data-aos="fade-up">{t("castle.castle5.date")}</small>
                        <p data-aos="fade-up">{t("castle.castle5.message")}</p>
                        <hr className='left-container-arrow'></hr>
                    </div>
                </div>
                <div className="timeline-container right-container">
                    <div className="timeline-container__text-box">
                        <img src="images/krenlaz.jpg" alt="Krenlaż zrobiony z kamienia" data-aos="fade-up" />
                        <h2 data-aos="fade-up">{t("castle.castle6.title")}</h2>
                        <small data-aos="fade-up">{t("castle.castle6.date")}</small>
                        <p data-aos="fade-up">{t("castle.castle6.message")}</p>
                        <hr className='right-container-arrow'></hr>
                    </div>
                </div>
                <div className="timeline-container left-container">
                    <div className="timeline-container__text-box">
                        <img src="images/podziemie.jpg" alt="Podziemia zbudowane z kamienia naturalnego w zamku Stobnicy" data-aos="fade-up" />
                        <h2 data-aos="fade-up">{t("castle.castle7.title")}</h2>
                        <small data-aos="fade-up">{t("castle.castle7.date")}</small>
                        <p data-aos="fade-up">{t("castle.castle7.message")}</p>
                        <hr className='left-container-arrow'></hr>
                    </div>
                </div>
            </section>

            <h2 className='text-center heading'>{t("castle.header1")}</h2>

            <section className="container-fluid mt-5">
                <div className="container-lg h-100">
                    <div className="row h-100 castle-uniqueness">
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 castle-uniqueness__col p-xl-5 p-lg-5 p-md-0 p-sm-0">
                            <img src={t("castle.list1")} className='d-block mx-auto' alt="Wyjątkowość zamku w Stobnicy" />
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 castle-uniqueness__col p-xl-5 p-lg-5 p-md-0 p-sm-0">
                            <img src={t("castle.list2")} className='d-block mx-auto' alt="Potwierdzenie budowy wieży w zamku w stobnicy" />
                        </div>
                    </div>
                </div>

            </section>

            <h2 className='heading-small text-center mb-5'>{t("castle.header2")}</h2>

            <div className="container-fluid castle__image-container">
                <Slider {...settings}>
                    <div data-aos="zoom-in-up" data-aos-delay="350" >
                        <img src="images/kostka_brukowa.jpg" id='castle__image1' className='p-3' alt="Podziemie" />
                    </div>
                    <div data-aos="zoom-in-up" data-aos-delay="150">
                        <img src="images/podziemie.jpg" id='castle__image2' className='p-3' alt="Krenlaż" />
                    </div>
                    <div data-aos="zoom-in-up" data-aos-delay="350">
                        <img src="images/kostkabrukowa.jpg" id='castle__image3' className='p-3' alt="Schody z kamienia naturalnego" />
                    </div>
                </Slider>
            </div>
        </>
    )

}

export default Castle